<div class="raycast">
  <cmdk-command [filter]="filterIndex">
    <div class="cmdk-top-badge">
      @for (p of pages; track p) {
        <div class="cmdk-badge">
          {{ p }}
        </div>
      }
      @if (activeIndex()) {
        <div class="cmdk-badge">
          {{ activeIndex() }}
        </div>
      }
    </div>
    <div class="search-input-wrapper d-flex align-items-center">
      @if (activeIndex()) {
        <app-action-btn
          [active]="false"
          [type]="'withIcon'"
          [IconType]="'arrow_left'"
          [size]="'small'"
          (click)="clearActiveIndex()"
          class="back-btn">
        </app-action-btn>
      }
      <input
        #searchInput
        cmdkInput
        [value]="searchQuery()"
        placeholder="Search for {{ activeIndex() ? activeIndex() : 'app and commands' }}"
        (input)="setSearch($event)"
        class="h4-reg" />
    </div>
    <cmdk-list class="cmdk-list-active custom-scroll">
      <!-- Search globally button - Show when there are local matches -->
      @if (
        searchQuery() && !hasLocalMatches() && !showApiResults() && !activeIndex() && hasResults()
      ) {
        <cmdk-group label="Search">
          <div class="results">
            <button
              cmdkItem
              [value]="'Search for ' + searchQuery()"
              class="suggestion-grid"
              (click)="triggerApiSearch()"
              (selected)="triggerApiSearch()">
              <div class="d-flex align-items-center justify-content-between w-100">
                <h4 class="h3-reg primary-60 suggestion-name d-flex align-items-center spacing-8">
                  <app-ce-icon [name]="'search'" [svg_class]="['primary-50']"></app-ce-icon>
                  Search for "{{ searchQuery() }}"
                </h4>
                <div class="indication h4-reg primary-60 d-flex align-items-center spacing-8">
                  <app-ce-icon
                    [name]="'arrow_right'"
                    class="arrow-icon"
                    [svg_class]="['primary-100']"></app-ce-icon>
                  Search globally
                </div>
              </div>
            </button>
          </div>
        </cmdk-group>
      }

      <!-- Suggestions Section - Only show in root when not showing API results -->
      @if (
        suggestions.length > 0 &&
        !activeIndex() &&
        (!searchQuery() || getFilteredItems(suggestions, searchQuery()).length > 0) &&
        (!showApiResults() || !searchQuery())
      ) {
        <cmdk-group label="Suggestions">
          <div class="results">
            @for (items of getFilteredItems(suggestions, searchQuery()); track items.index) {
              <button
                cmdkItem
                [value]="items.name"
                class="suggestion-grid"
                (click)="itemClick(items)"
                (selected)="itemClick(items)">
                <div class="d-flex align-items-center justify-content-between w-100">
                  <h4 class="h3-reg primary-60 suggestion-name d-flex align-items-center spacing-8">
                    <app-ce-icon [name]="items.icon" [svg_class]="['primary-50']"></app-ce-icon>
                    {{ items.name }}
                  </h4>
                  <span class="shortcut">
                    <span class="lable_name h4-reg text-nowrap primary-60">{{ items.key }}</span>
                  </span>
                </div>
              </button>
            }
          </div>
        </cmdk-group>
      }

      <!-- Commands Section - Only show in root when not showing API results -->
      @if (
        commands.length > 0 &&
        !activeIndex() &&
        (!searchQuery() || getFilteredItems(commands, searchQuery()).length > 0) &&
        (!showApiResults() || !searchQuery())
      ) {
        <cmdk-group label="Commands">
          <div class="results">
            @for (command of getFilteredItems(commands, searchQuery()); track command.index) {
              <button
                cmdkItem
                [value]="command.name"
                class="suggestion-grid"
                (click)="itemClick(command)"
                (selected)="itemClick(command)">
                <div class="d-flex align-items-center justify-content-between w-100">
                  <h4 class="h3-reg primary-60 suggestion-name d-flex align-items-center spacing-8">
                    <app-ce-icon [name]="command.icon" [svg_class]="['primary-50']"></app-ce-icon>
                    @if (command.index === 'Theme' || command.index === 'Mode') {
                      Switch to
                      {{
                        command.index === 'Theme'
                          ? currentTheme() === 'light'
                            ? 'Dark'
                            : 'Light'
                          : currentMode() === 'live'
                            ? 'Sandbox'
                            : 'Live'
                      }}
                      @if (command.index === 'Theme') {
                        Theme
                      } @else {
                        Mode
                      }
                    } @else {
                      {{ command.name }}
                    }
                  </h4>
                  @if (command.key) {
                    <span class="shortcut">
                      <span class="lable_name h4-reg text-nowrap primary-60">{{
                        command.key
                      }}</span>
                    </span>
                  }
                </div>
              </button>
            }
          </div>
        </cmdk-group>
      }

      <!-- Navigation Section - Show everywhere when there are local matches OR when no API results are being shown -->
      @if (
        navigations.length > 0 &&
        (!searchQuery() || getFilteredItems(navigations, searchQuery()).length > 0) &&
        (!showApiResults() || !searchQuery())
      ) {
        <cmdk-group label="Navigation">
          <div class="results">
            @for (menu of getFilteredItems(navigations, searchQuery()); track menu.route) {
              <button
                cmdkItem
                [value]="menu.name"
                class="suggestion-grid"
                (click)="menuClick(menu)"
                (selected)="menuClick(menu)">
                <div class="d-flex align-items-center justify-content-between w-100">
                  <h4 class="h3-reg primary-60 suggestion-name d-flex align-items-center spacing-8">
                    <app-ce-icon [name]="menu.icon" [svg_class]="['primary-50']"></app-ce-icon>
                    {{ menu.name }}
                  </h4>
                  <div class="indication h4-reg primary-60 d-flex align-items-center spacing-8">
                    <app-ce-icon
                      [name]="'arrow_right'"
                      class="arrow-icon"
                      [svg_class]="['primary-100']"></app-ce-icon>
                    Go to {{ menu.name }}
                    @if (menu.shortcut) {
                      <span class="shortcut d-flex align-items-center spacing-2">
                        @for (key of menu.shortcut; track $index) {
                          <span class="lable_name h4-reg text-nowrap primary-60">{{
                            key.toUpperCase()
                          }}</span>
                        }
                      </span>
                    }
                  </div>
                </div>
              </button>
            }
          </div>
        </cmdk-group>
      }

      <!-- Search Results Section - Show when API search is triggered -->
      @if (shouldTriggerApi()) {
        <app-global-loader-wrapper
          [resource]="searchResource"
          [emptyMessage]="'No results found for ' + searchQuery()">
          <ng-template>
            @for (results of searchResource.value(); track results; let j = $index) {
              <cmdk-group
                *ngIf="searchQuery()"
                [label]="
                  results['indexUid'].includes('customers')
                    ? 'Customers'
                    : results['indexUid'].includes('orders')
                      ? 'Orders'
                      : 'Products'
                ">
                <div class="results">
                  <div class="search-results">
                    @for (item of results.hits; track item.id || i; let i = $index) {
                      @if (results['indexUid'].includes('customers')) {
                        <button
                          class="grid d-flex align-items-start w-100"
                          [value]="
                            item.id +
                            ' ' +
                            (item.full_name || '') +
                            ' ' +
                            (item.email || '') +
                            ' ' +
                            (item.phone || '') +
                            ' ' +
                            (item.first_name || '')
                          "
                          cmdkItem
                          (click)="onCustomer(item.id)"
                          (selected)="onCustomer(item.id)">
                          <div class="media d-flex spacing-8">
                            <div class="media-left">
                              <div class="avatar">
                                <app-avatar-icon
                                  seed="{{ item?.full_name }}"
                                  [size]="32"></app-avatar-icon>
                              </div>
                            </div>
                            <div
                              class="media-body d-flex align-items-start justify-content-between w-100">
                              <div class="d-flex flex-column align-items-start">
                                <h4 class="h3-reg m-0 d-flex align-items-center gap">
                                  {{ item.full_name ? item.full_name : 'N/a' }}
                                  <app-ce-icon
                                    [name]="'verified'"
                                    [svg_class]="['success-120']"></app-ce-icon>
                                </h4>
                              </div>
                              @if (!activeIndex()) {
                                <div class="indication h4-reg primary-60">Customer</div>
                              }
                            </div>
                          </div>
                        </button>
                      } @else if (results['indexUid'].includes('orders')) {
                        <button
                          class="grid spacing-16 widgets order-block"
                          [class.cmdk-item-active]="i === 0"
                          cmdkItem
                          [value]="
                            item.order_number +
                            ' ' +
                            (item.billing_address?.first_name || '') +
                            ' ₹ ' +
                            (item.grand_total || '') +
                            ' ' +
                            (item.status || '')
                          "
                          (click)="onOrder(item.order_number)"
                          (selected)="onOrder(item.order_number)">
                          <div class="d-flex align-items-center w-100">
                            <app-blocks
                              class="w-100 cursor-pointer"
                              [order]="item.order_number"
                              [container_icon]="''"
                              [view_detail]="false"
                              [store_icon]="'amazon'"
                              [store]="false"
                              [date]="item.billing_address.first_name"
                              [price]="true"
                              [status]="true"
                              [statusType]="getOrderStatus(item.status)"
                              [status_label]="item.status"
                              [amount]="item.grand_total.toString()"
                              [state]="'without-container'"></app-blocks>
                          </div>
                        </button>
                      } @else if (results['indexUid'].includes('products')) {
                        <button
                          class="grid spacing-16 widgets"
                          [class.cmdk-item-active]="i === 0"
                          [value]="
                            item.id +
                            ' ' +
                            (item.product_id || '') +
                            ' ' +
                            (item.variant_id || '') +
                            ' ' +
                            (item.variant_name || '') +
                            ' ' +
                            (item.product_name || '') +
                            ' ' +
                            (item.name || '')
                          "
                          cmdkItem
                          (click)="onProduct(item.product_id, item.variant_id)"
                          (selected)="onProduct(item.product_id, item.variant_id)">
                          <div class="d-flex align-items-center w-100">
                            <div class="media d-flex spacing-8">
                              <div class="media-left">
                                <div class="product-img">
                                  <img
                                    class="w-100"
                                    alt=""
                                    height="137"
                                    width="293"
                                    [src]="
                                      item.images?.length > 0
                                        ? item.images[0]?.url_thumbnail
                                        : '/assets/No-Image-Placeholder.svg'
                                    " />
                                </div>
                              </div>
                              <div
                                class="media-body d-flex align-items-start justify-content-between w-100">
                                <div class="d-flex flex-column align-items-start">
                                  <h4 class="h3-reg m-0 d-flex align-items-center">
                                    {{ item.variant_id ? item.variant_name : item.product_name }}
                                  </h4>
                                </div>
                                @if (!activeIndex()) {
                                  <div class="indication h4-reg primary-60">
                                    {{ item.variant_id ? 'Variant' : 'Product' }}
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </button>
                      }
                    }
                  </div>
                </div>
              </cmdk-group>
            }
          </ng-template>
        </app-global-loader-wrapper>
      }
    </cmdk-list>
  </cmdk-command>
</div>
